import { handleResponseError } from 'helpers/utils'
import { API } from './endpoint'
import { GetAgentListResponse, GetContactByIdResponse, CancelHandshakeInput, CancelHandshakeResponse, GetAgentListInput, ExportAgentListResponse, ExportAgentListInput, deleteAgentImmediatelyResponse, deleteAgentImmediatelyInput } from './interface'
import httpClient from '../axios/interceptors'
import { AxiosResponse } from 'axios'



export const getAgentsList = async (
  input: GetAgentListInput
  ): Promise<GetAgentListResponse> => {
  const data: AxiosResponse<GetAgentListResponse> = await httpClient
    .post(API.getAgentsList, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getAgentById = async (
  agentId: string
): Promise<GetContactByIdResponse> => {
  const data: AxiosResponse<GetContactByIdResponse> = await httpClient
    .get(API.getAgentById + agentId)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const cancelHandshake = async (
  input: CancelHandshakeInput
): Promise<CancelHandshakeResponse> => {
  const data: AxiosResponse<CancelHandshakeResponse> = await httpClient
    .post(API.cancelHandshake, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getExportAgentList = async (input:ExportAgentListInput ): Promise<ExportAgentListResponse> => {
  const data: AxiosResponse<ExportAgentListResponse> = await httpClient
    .post(API.exportAgentList, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const deleteAgentImmediately = async (
  input: deleteAgentImmediatelyInput
): Promise<deleteAgentImmediatelyResponse> => {
  const data: AxiosResponse<deleteAgentImmediatelyResponse> = await httpClient
    .post(API.deleteAgentImmediately, input)
    .catch((error) => handleResponseError(error))
  return data.data
}